// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBGZpgOZtAzOUp1TO2UycJcI9ggTP8NfWk",
  authDomain: "refrigeration-versification.firebaseapp.com",
  projectId: "refrigeration-versification",
  storageBucket: "refrigeration-versification.appspot.com",
  messagingSenderId: "758212477352",
  appId: "1:758212477352:web:8ef3dadb4265cfc5f2dd9d"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export default app;